<template>
  <v-row>
    <v-col>
      <v-dialog ref="dialog" v-model="modalIni" width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="iniTime"
            :disabled="disabled"
            ref="iniTime"
            label="Hora de inicio"
            :rules="rulesIni"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="modalIni"
          v-model="iniTime"
          format="24hr"
          max="19:00"
          min="9:00"
          :allowedMinutes="computedAllowedMinutes"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modalIni = false">
            Cancelar
          </v-btn>
          <v-btn text color="primary" @click="modalIni = false">
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
    <v-col>
      <v-dialog ref="dialog" v-model="modalFin" persistent width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="finTime"
            :disabled="disabled"
            ref="endTime"
            :rules="rulesFin"
            label="Hora de fin"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="modalFin"
          v-model="finTime"
          format="24hr"
          max="20:00"
          :min="iniTime"
          :allowedMinutes="computedAllowedMinutes"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modalFin = false">
            Cancelar
          </v-btn>
          <v-btn text color="primary" @click="modalFin = false">
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ['timeInicio', 'timeFin', 'rulesFin', 'rulesIni', 'disabled', 'onlyHours'],
  name: 'OTimeRangeHidePicker',
  data() {
    return {
      modalIni: false,
      modalFin: false
    }
  },
  computed: {
    iniTime: {
      get() {
        return this.timeInicio
      },
      set(newVal) {
        console.log(newVal)
        this.$emit('updateTimeInicio', newVal)
      }
    },
    finTime: {
      get() {
        return this.timeFin
      },
      set(newVal) {
        this.$emit('update:timeFin', newVal)
      }
    },
    computedAllowedMinutes() {
      // Si onlyHour es true, devuelve la función que solo permite el minuto 0
      if (this.onlyHours) {
        return minute => minute === 0
      }
      // Si onlyHour es false, permite todos los minutos (o null para comportamiento por defecto)
      return null // O puedes devolver una función que siempre retorne true: (minute) => true
    }
  },
  methods: {},
  watch: {
    // Emitir el cambio cuando la variable interna cambie
    finTime(newValue) {
      // Si onlyHour es true, nos aseguramos de que los minutos sean "00" antes de emitir
      if (this.onlyHour && newValue) {
        const [hour] = newValue.split(':')
        this.$emit('input', `${hour}:00`)
      } else {
        this.$emit('input', newValue)
      }
    },
    iniTime(newValue) {
      // Si onlyHour es true, nos aseguramos de que los minutos sean "00" antes de emitir
      if (this.onlyHour && newValue) {
        const [hour] = newValue.split(':')
        this.$emit('input', `${hour}:00`)
      } else {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
